export enum ScreenItemStatus {
    Committed = 0,
    New = 1,
    Changed = 2,
    Deleted = 3,
    EncodedAndReady = 5
}